<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <!--<div v-if="response" class="form">
        <label class="pay-label">Estorno realizado com sucesso!</label>
        <label class="pay-label">Tiketera</label>
        <div class="pay-value">{{ response.tiketera.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
        <label class="pay-label">Estabelecimento</label>
        <div class="pay-value">{{ response.business.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
        <label class="pay-label">Identificador</label>
        <div class="pay-value">{{ response.data.refund.id }}</div>
      </div>-->
      <form @submit.prevent="refund" class="form">
        <label class="pay-label">Cliente</label>
        <div class="pay-value">{{ transaction.customer }}</div>
        <label class="pay-label">Data</label>
        <div class="pay-value">{{ transaction.date }}</div>
        <label class="pay-label">Valor</label>
        <div class="pay-value">{{ (transaction.refundTotal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
        <label class="pay-label">Motivo</label>
        <textarea v-model="reason" rows="3" :class="{ error : error.indexOf('reason') > -1 }" />
        <div v-if="error.indexOf('reason') > -1" class="hint">você esqueceu o motivo</div>
        <div v-if="errorMsg" class="hint">{{ errorMsg }}</div>
        <button type="submit" class="button-save" style="margin-top: 30px"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { refund } from '../api/transaction'
// import Selector from './Selector'

export default {
  name: 'TransactionRefund',
  // components: { Selector },
  props: ['transaction', 'close'],
  data () {
    return {
      title: 'Realizar Estorno',
      loading: false,
      error: [],
      errorMsg: null,
      reason: null,
      response: null
    }
  },
  methods: {
    async refund () {
      try {
        this.loading = true
        this.response = null
        this.error = []
        this.errorMsg = null
        const response = await refund(this.transaction.id, this.reason)
        if (response === 'OK') {
          // this.title = 'Estorno finalizado'
          this.$message.success('A assinatura foi cancelada', { duration: 3000 })
          this.close()
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else if (data.error === 'Refund error') {
          this.errorMsg = `${data.code} - ${data.message}`
        } else {
          this.errorMsg = 'Erro interno! Tente novamente.'
          logger.error(error)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.pay-label {
  color: $primary-color;
  font-weight: 500;
  font-size: 0.85em;
}

.pay-value {
  margin-top: 3px;
  color: #777;
  max-height: 100px;
  overflow-y: auto;
}
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
</style>
